import { combineReducers } from '@ynap/reducer-utils'
import * as reducers from './reducers'

const reservationsReducer = combineReducers({ ...reducers })

export default reservationsReducer
